import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimRadioGroup, ClaimTextField } from '../fields';

// Helper to convert boolean to string for RadioGroup, handling null/undefined properly
const boolToRadioValue = (value: boolean | undefined | null): string => {
  if (value === true) return 'true';
  if (value === false) return 'false';
  return '';
};

export const Box11_InsuredPolicy: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">{"11. INSURED'S POLICY GROUP OR FECA NUMBER"}</Typography>
      <Controller
        name="insuredPolicyGroup"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
            sx={{ mb: 0.5 }}
          />
        )}
      />

      <Box display="flex" gap={1} alignItems="flex-start" mb={0.5}>
        <Box flex={1} display="flex" flexDirection="column" gap={1}>
          <Typography variant="caption">{"a. INSURED'S DATE OF BIRTH"}</Typography>
          <Controller
            name="insuredDateOfBirth"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                type="date"
                size="small"
                fullWidth
              />
            )}
          />
        </Box>
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography variant="caption">SEX</Typography>
          <Controller
            name="insuredSex"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimRadioGroup
                field={field}
                fieldState={fieldState}
                options={[
                  { value: 'M', label: 'M' },
                  { value: 'F', label: 'F' },
                ]}
                row
              />
            )}
          />
        </Box>
      </Box>

      <Typography variant="caption">b. OTHER CLAIM ID</Typography>
      <Controller
        name="otherClaimId"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
            sx={{ mb: 0.5 }}
          />
        )}
      />

      <Typography variant="caption">c. INSURANCE PLAN NAME</Typography>
      <Controller
        name="insuredPlanName"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
            sx={{ mb: 0.5 }}
          />
        )}
      />

      <Box>
        <Typography variant="caption">d. IS THERE ANOTHER HEALTH BENEFIT PLAN?</Typography>
        <Controller
          name="otherHealthPlan"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimRadioGroup
              field={field}
              fieldState={fieldState}
              options={[
                { value: true, label: 'YES' },
                { value: false, label: 'NO' },
              ]}
              valueConverter={boolToRadioValue}
              onChangeConverter={(val) => val === 'true' ? true : val === 'false' ? false : undefined}
              row
            />
          )}
        />
      </Box>
    </>
  );
};